import ProductGrid from "@/components/ProductGrid";

export default function BodyOil() {
  return (
    <ProductGrid
      category="body-oil"
      eyebrow="Body Oil Collection"
      title="Featherlight. Silky. Scented."
      blurb="A silk-finish body oil hand-blended in your chosen scent. Slip it on after a shower, tuck the small size in your bag for the day."
    />
  );
}
